import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getAdminProgramById } from '../../shared/api/programs.services';
import ProgramsContentForm from '../../features/programs-content-form/ui/ProgramsContentForm';
import AdminPageLoader from '../../shared/ui/admin-loader/AdminPageLoader';
import toast from '../../shared/lib/toast';

const ProgramsContentEditPage = () => {
  const { programId } = useParams();
  const navigate = useNavigate();
  const [program, setProgram] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProgram = async () => {
      setLoading(true);
      try {
        const data = await getAdminProgramById(programId);
        setProgram(data);
      } catch (err) {
        console.error('Error fetching program:', err);
        setError(err.message || 'Помилка при завантаженні програми');
        toast.error('Помилка при завантаженні програми');
      } finally {
        setLoading(false);
      }
    };

    fetchProgram();
  }, [programId]);

  if (loading) {
    return <AdminPageLoader label="Завантаження..." fullScreen />;
  }

  if (error) {
    return (
      <div className="page-wrapper">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (!program) {
    return (
      <div className="page-wrapper">
        <div className="error-message">Програму не знайдено</div>
      </div>
    );
  }

  return (
    <>
      <section className="section-admin section-form">
        <div className="section-form__header">
          <h2>Програма: {program.title?.ua || program.title}</h2>
          <button onClick={() => navigate('/programs')}>Повернутися</button>
        </div>

        <ProgramsContentForm initialData={program} />
      </section>

      <button form="programs-content-form" className="product-form__submit" type="submit">
        Зберегти
      </button>
    </>
  );
};

export default ProgramsContentEditPage;
